// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as VehicleListCmp from "./VehicleListCmp.bs.js";
import * as NoAccessViewCmp from "./NoAccessViewCmp.bs.js";
import * as GeoRegionListCmp from "./GeoRegionListCmp.bs.js";
import * as AllocationUserPrompt from "./sidebar/sidebar-screens/reusable-components/AllocationUserPrompt.bs.js";
import * as AllocationDashboardHome from "./allocation-dashboard-home/AllocationDashboardHome.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as CrmControlledReleaseContext from "../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";
import * as AllocationDashboardDataMachine from "../../app/repo/AllocationDashboardDataMachine.bs.js";
import * as AllocationDashboardStateMachine from "./AllocationDashboardStateMachine.bs.js";
import * as AllocationDashboardAssetsManager from "../assets/AllocationDashboardAssetsManager.bs.js";
import * as AllocationDashboardSidebarContainer from "./sidebar/AllocationDashboardSidebarContainer.bs.js";

AllocationDashboardAssetsManager.importCss(undefined);

function AllocationDashboardContainer(Props) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$1[1];
  var match$2 = React.useReducer(AllocationDashboardStateMachine.reducer, AllocationDashboardStateMachine.intitial_state);
  var dispatch = match$2[1];
  var state = match$2[0];
  var adminBetaPageAccessData = React.useContext(CrmControlledReleaseContext.context);
  React.useEffect((function () {
          AllocationDashboardDataMachine.getUserAccessLevel(adminBetaPageAccessData.adminBetaAccessData.admin.email, (function (roles) {
                  return Curry._1(dispatch, {
                              TAG: /* SetUserRole */0,
                              user_role: {
                                TAG: /* Live */1,
                                _0: roles
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetUserRole */0,
                              user_role: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), country);
          
        }), []);
  React.useEffect((function () {
          var role = state.user_role;
          if (typeof role !== "number" && role.TAG === /* Live */1) {
            var match = role._0.access_level;
            if (match >= 3) {
              Curry._1(dispatch, {
                    TAG: /* UpdateCurrentView */8,
                    current_view: /* NoAccessView */4
                  });
            } else {
              Curry._1(dispatch, {
                    TAG: /* UpdateCurrentView */8,
                    current_view: /* GeoRegionView */1
                  });
            }
          }
          
        }), [state.user_role]);
  React.useEffect((function () {
          var message_to_show = state.snackbar_message;
          if (message_to_show !== undefined) {
            Curry._1(openSnackbar, message_to_show);
            Curry._1(dispatch, /* ClearSnackbar */0);
            return ;
          }
          
        }), [state.snackbar_message]);
  var sidebar = state.opened_sidebar;
  var tmp;
  if (sidebar !== undefined) {
    var match$3 = state.selected_geo_region;
    var match$4 = state.selected_vehicle;
    var match$5 = state.filtered_allocation_campaings;
    var match$6 = state.user_role;
    tmp = match$3 !== undefined && match$4 !== undefined && !(typeof match$5 === "number" || !(match$5.TAG === /* Live */1 && !(typeof match$6 === "number" || match$6.TAG !== /* Live */1))) ? React.createElement(AllocationDashboardSidebarContainer.make, {
            vehicle: match$4,
            geo_region: match$3,
            zones: state.zones,
            clusters: state.clusters,
            campaigns_list: match$5._0,
            sidebar: sidebar,
            user_role: match$6._0,
            zone_cluster_campaigns_list: state.zoneClusterCampaigns,
            dispatch: dispatch
          }) : null;
  } else {
    tmp = null;
  }
  var modal_data = state.modal;
  var match$7 = state.current_view;
  var tmp$1;
  switch (match$7) {
    case /* InitialView */0 :
        tmp$1 = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case /* GeoRegionView */1 :
        tmp$1 = React.createElement(GeoRegionListCmp.make, {
              state: state,
              dispatch: dispatch
            });
        break;
    case /* VehicleListView */2 :
        tmp$1 = React.createElement(VehicleListCmp.make, {
              state: state,
              dispatch: dispatch
            });
        break;
    case /* AllocationDashboardHome */3 :
        tmp$1 = React.createElement(AllocationDashboardHome.make, {
              state: state,
              dispatch: dispatch
            });
        break;
    case /* NoAccessView */4 :
        tmp$1 = React.createElement(NoAccessViewCmp.make, {});
        break;
    
  }
  return React.createElement("div", {
              className: "container"
            }, React.createElement("div", undefined, tmp, modal_data !== undefined ? React.createElement(AllocationUserPrompt.make, {
                        modal_data: modal_data
                      }) : null, match$1[0], tmp$1));
}

var make = AllocationDashboardContainer;

export {
  make ,
  
}
/*  Not a pure module */
